
import { tripToTripMutation } from '@util/tripMapper';
import Vue from 'vue';
import { Trip, TripMutation } from '@clients/myTrips';
import { Component, Prop } from 'vue-property-decorator';
import AppButton from '@components/new-styleguide/AppButton.vue';
import deepCopy from "@util/copy";

@Component({
  name: 'TripDataWorkNote',
  components: {
    AppButton
  }
})

export default class TripDataWorkNote extends Vue {
  $refs!: {
    note: HTMLFormElement
  }

  @Prop({ default: false })
  private addMode: boolean;

  @Prop()
  private trip: Trip;

  @Prop()
  private tripMutation: TripMutation;

  @Prop({ default: false })
  private loading: boolean;

  get editMode() {
    return !!this.tripMutation;
  }

  get work() {
    if (this.loading) {
      return false;
    }
    return this.editMode || this.addMode ? this.tripMutation.work : this.trip.work;
  }

  get note() {
    return this.editMode || this.addMode ? this.tripMutation.note : this.trip.note;
  }

  public focusField() {
    this.$refs.note.focus();
  }

  private handleNoteChange(note: string) {
    const copy = deepCopy(this.tripMutation);
    copy.note = note;
    this.$emit('input', copy);
  }

  private handleWorkChange(work: boolean) {
    const copy = this.editMode || this.addMode ? deepCopy(this.tripMutation) : tripToTripMutation(this.trip);

    if (!this.editMode && !this.addMode) {
      this.emitEdit();
    }

    copy.work = work;
    this.$emit('input', copy);
  }

  get noteText() {
    if (this.loading) {
      return "Wird geladen...";
    }
    return this.trip && this.trip.note ? this.trip.note : 'Keine Beschreibung';
  }

  private emitEdit() {
    if (!this.loading) {
      this.$emit('toggleEditMode', 'note');
    }
  }
}
